import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Animation, AnimationController, IonFooter, IonNav } from '@ionic/angular';
import { IBorclandir, IMasrafKalemi, IMasrafMerkezi } from '@models/finance';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-borclandir',
  templateUrl: './borclandir.component.html',
  styleUrls: ['./borclandir.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class BorclandirComponent implements OnInit {
  @Input() borclandir: IBorclandir;
  @ViewChild(IonFooter, { read: ElementRef }) footer: ElementRef;

  public today: string = new Date().toISOString();
  public borclandirForm: FormGroup;
  public masrafMerkezi: IMasrafMerkezi[] = [{ masrafID: 1, masrafAdi: 'Masraf Merkezi 1', varsayilan: false }, { masrafID: 2, masrafAdi: 'Masraf Merkezi 2', varsayilan: false }];
  public masrafKalemi: IMasrafKalemi[] = [{ masrafKalemiID: 1, masrafKalemi: 'Masraf Kalemi 1', altHesapTurID: 123 }, { masrafKalemiID: 2, masrafKalemi: 'Masraf Kalemi 2', altHesapTurID: 723 }];

  private footerFadeIn: Animation;
  private footerFadeOut: Animation;

  constructor(
    private formBuilder: FormBuilder,
    private animationController: AnimationController,
    private nav: IonNav,
  ) { }

  ngOnInit(): void {
    this.createBorclandirForm();
  }

  ionViewWillEnter() {
    this.footerFadeIn = this.animationController
      .create()
      .addElement(this.footer.nativeElement)
      .fill('forwards')
      .duration(250)
      .easing('ease-out')
      .iterations(1)
      .fromTo('transform', 'translateY(150px)', 'translateY(0px)')
      .fromTo('opacity', '0', '1');

    this.footerFadeOut = this.animationController
      .create()
      .addElement(this.footer.nativeElement)
      .fill('forwards')
      .duration(250)
      .easing('ease-in')
      .iterations(1)
      .fromTo('transform', 'translateY(0px)', 'translateY(150px)')
      .fromTo('opacity', '1', '0');
  }

  ionViewDidEnter() {
    this.footerFadeIn.play();
  }

  ionViewWillLeave() {
    this.footerFadeOut.play();
  }

  createBorclandirForm() {
    this.borclandirForm = this.formBuilder.group({
      tarih: [this.today, Validators.required],
      masrafMerkezi: [null, Validators.required],
      masrafKalemi: [null, Validators.required],
      tutar: [null, Validators.required],
      aciklama: ['', Validators.required]
    });
  }

  saveForm() {
    if (this.borclandirForm.valid) {
      let borclandirModel = Object.assign({}, this.borclandirForm.value);
      Swal.fire({
        toast: true,
        icon: 'success',
        title: 'Kaydetme Başarılı',
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: false,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      }).then(() => {
        this.goback();
      });
      console.log(borclandirModel);
    }
  }

  async goback() {
    this.nav.popToRoot();
  }
}
